import React from 'react';
import { Button } from 'react-bootstrap';
import '../barcodeStyle.css'

function BarcodePrintDialogBox({ children, printAreaRef }) {
    return (
        <>
            <div className="barcodePrintContainer mt-3 mb-5 d-flex justify-content-center">
                <div ref={printAreaRef} className='barcodePrintArea'>
                    {children}
                </div>
            </div>
        </>
    );
}

export default BarcodePrintDialogBox;